import { ClientEvent } from '@udemy/event-tracking';

// TODO: Discuss with experimentation platform where this event should actually live.
export class ExperimentImpressionEvent extends ClientEvent {
  constructor(experimentIds, isLocalDefaultShown) {
    super('ExperimentImpressionEvent');
    this.experimentIds = void 0;
    this.isLocalDefaultShown = false;
    this.experimentIds = experimentIds;
    this.isLocalDefaultShown = isLocalDefaultShown;
  }
}
//# sourceMappingURL=events.js.map